import React from 'react'
import Button from 'js/components/Button/Button'

type Props = {
  url: string
  buttonText: string
  /* used by DownloadCtaBlock */
  download?: string
}

export default function CtaBlock({ buttonText, url, download }: Props) {
  return (
    <div className="mx-auto my-32 w-full max-w-480">
      <Button big block href={url} download={download} use="a">
        {buttonText}
      </Button>
    </div>
  )
}
